<div class="container">
  <p>
    <b>
      <u>
        <span style="font-size: 16pt; line-height: 107%; color: #0d0d0d">OUTDOOR ACCESS TERMS OF SERVICE</span>
      </u>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >PLEASE READ THE FOLLOWING TERMS OF SERVICE RELATING TO YOUR USE OF THIS WEBSITE CAREFULLY. BY USING THIS WEBSITE, YOU ARE DEEMED TO
      HAVE AGREED TO THESE TERMS OF SERVICE. IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS OF SERVICE, DO NOT PROCEED ANY FURTHER AND DO
      NOT USE THIS WEBSITE. We reserve the right to modify these terms at any time and you should check these Terms of Service periodically
      for changes. By using the Website after we post any changes to these terms, you agree to accept those changes, whether or not you have
      reviewed them. If at any time you choose not to accept these Terms of Service, please do not use the Website.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">SCOPE OF TERMS OF USE</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Outdoor Access, Inc. (&quot;OA,&quot; &quot;we&quot; and &quot;us&quot;), owns Outdooraccess.com (&quot;Website&quot;), an online platform that connects landowners who have
      land with guests seeking to use such land for hunting or other outdoor activities (the &quot;Services&quot;). For purposes of these
      Terms of Service, &quot;Website&quot; refers to any other websites and services owned or operated by OA, now or in the future, any applications
      that we make or may make available on mobile devices now or in the future (&quot;Apps&quot;), including but not limited to the Outdoor Access
      App (see Changes to App License and App License below) and any and all Outdoor Access social media platforms (&quot;Social Media&quot;) from
      which you accessed these Terms of Service or on which you post User Content as described herein. Note that specific terms of use of a
      social media platform may apply depending upon the Social Media platform you choose to use.</span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA is based in Virginia, in the United States of America. We provide the Services for use only by persons who are at least eighteen
      (18) years of age and located in the United States. We make no claims that the Services or the Website or any of its content is
      accessible or appropriate outside of the United States. Access to the Website may not be legal by certain persons or in certain
      countries. If you access or use the Website from outside the United States, you do so on your own initiative and are responsible for
      compliance with those laws.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">CONSTRUCTION OF THESE TERMS OF SERVICE</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">These Terms of Service are divided into three sections. Section 1 contains general terms applicable to all users and visitors to the
      Website and the Services as well as to Members and Landowners (as those terms are defined herein); Section 2 contains terms specific
      to Members only; and Section 3 contains terms specific to Landowners only. As there will be some overlapping of terms, please read the
      complete Terms of Service thoroughly so you fully understand the applicable sections and you are aware of your obligations.</span>
  </p>

  <p>
    <b>
      <i>
        <u>
          <span style="font-size: 14pt; line-height: 107%; color: #0d0d0d">SECTION 1.  General</span>
        </u>
      </i>
    </b>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ACCEPTANCE OF TERMS OF SERVICE </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >These Terms of Service are entered into by and between you and OA and together with any other agreements, documents, or terms which are incorporated by
      reference herein (collectively, these &quot;Terms of Service&quot; or &quot;Terms&quot;), govern your access to and use of the Website including any content,
      functionality, and services offered on or through it. These Terms of Service apply to Landowners, Members, and users and visitors to
      the Website (&quot;you&quot;, &quot;your&quot;). Where a provision is specific to a subset of this list (e.g. Members only), we will state that in the
      provision.</span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >By using the Website, you accept and agree to be bound and abide by these Terms of Service, including our Privacy Policy and any and all other
      agreements, documents or terms which are incorporated by reference herein (collectively referred to as the &quot;Agreements&quot;). If you do
      not want to agree to the Agreements, you must not access or use the Website.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">CHANGE TO TERMS OF SERVICE</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA reserves the right, at its sole discretion, to change these Terms of Service, in whole or in part, at any time
      and without prior notice to you. If we change the Terms of Service, we will endeavor to provide you with notice of the change on the Website or other
      location as applicable. We will also update the &quot;Last Updated&quot; date on the Website, Terms or Service or other updated
      location. Your continued use of the Services shall constitute consent to any changes or updates.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">CHANGES TO APP</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We may from time to time develop and provide App updates, which may include upgrades, bug fixes, patches, other error corrections,
      and/or new features (&quot;Updates&quot;), which may also modify or delete in their entirety certain features and functionality. You agree that
      we have no obligation to provide any updates or modifications, or to continue to provide or enable any particular features or
      functionality of the App. Based on your Mobile Device settings, when your Mobile Device is connected to the internet either:</span
    >
  </p>

  <p>
    <span style="color: #0d0d0d">(a)the App will automatically download and install all available updates; or</span>
  </p>

  <p>
    <span style="color: #0d0d0d">(b)you may receive notice of or be prompted to download and install available updates. </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You shall promptly download and install all Updates and acknowledge and agree that the Application or portions thereof may not
      properly operate should you fail to do so. You further agree that all Updates will be deemed part of the App and be subject to these
      Terms of Service.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">HOW THE SERVICE WORKS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >The Service facilitates the listing of land (&quot;Property&quot;) by owners or operators of the land (&quot;Landowners&quot;) and the booking of such
      listed Properties (&quot;Booking&quot;) by third parties (&quot;Members&quot;)  who want to reserve the Property for hunting, camping or other outdoor
      activity available and as specified by the Landowner on the listing of the Property (&quot;Listing&quot;) description.</span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You may visit our Website to view Listings or Properties without being a Member.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ACCOUNT REGISTRATION</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >To book a Property and/or create a Listing you will need to set up an OA account (&quot;Account&quot;). When you create an Account, you will be
      prompted to choose whether you want to be a Landowner or a Member. Any account holder may create a Booking provided s/he meets the requirements of that listing.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Accounts may be set up via the Website or the App. Once you have registered an Account, your Account profile page will be created
      for your use of the Service based upon the personal information you provide to us. You may not have more than one (1) active Account.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You agree to provide accurate, current and complete information during the registration process and to update any changes to such
      information.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ACCOUNT SECURITY</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You are responsible for safeguarding your Account password. You agree that you will not disclose your password to any third party and
      that you will take sole responsibility for any activities or actions under your Account, whether or not you have authorized such
      activities or actions. You will immediately notify OA of any unauthorized use of your Account(s). You also agree to ensure that you
      exit from your Account at the end of each session. You should use particular caution when accessing your Account from a public or
      shared computer so that others are not able to view or record your password or other personal information.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ACCOUNT TERMINATION</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You may terminate or deactivate your Account and end your legal agreement with OA at any time by deactivating your account and
      discontinuing your use of the Service.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We may suspend or terminate your Account or cease providing you with all or part of the Services at any time for any or no reason,
      including, but not limited to, if we reasonably believe: (i) you have violated these Terms of Service, (ii) you create risk or
      possible legal exposure for us or other users of the Website; (iii) removal due to prolonged inactivity; or (iv) our provision of the Services to
      you is no longer commercially viable. Further we may terminate your Account if you create more than one Account (other than as
      specified herein) or if any information provided during the registration process or thereafter proves to be inaccurate, fraudulent,
      not current, or incomplete.</span
    >
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We will make reasonable efforts to notify you by the email address associated with your Account or the next time you attempt to
      access your Account, depending on the circumstances. In all such cases, the Terms of Service shall terminate with regard to your use
      of the Website or your Account, including, without limitation, any license granted herein, except that the provisions of these Term of
      Service that reasonably should survive termination will remain in effect.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">NO ENDORSEMENT</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA does not make any representations about, confirm, or endorse any Property, Member or Landowner, or the purported identity or background of
      the Member or Landowner. By using the Service, you agree that any legal remedy or liability that you seek to obtain for actions or
      omissions of other Members, Landowners, or other third parties will be limited to a claim against the particular Member(s),
      Landowner(s), or other third parties who caused you harm. You agree not to attempt to impose liability on or seek any legal remedy
      from OA with respect to such actions or omissions. We encourage Landowners and Members to communicate directly with each other
      regarding any Bookings or Listings. This limitation shall not apply to any claim by a Landowner against OA regarding the remittance of
      payments received by OA on behalf of a Landowner, which instead shall be subject to the limitations described in the
      section below entitled &quot;Limitation of Liability&quot;.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">SCREENING OF PERSONAL INFORMATION</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      If you desire to create a Booking, you authorize OA, through our background check process as further outlined below, to make inquiries 
      we consider necessary to help verify or check your identity or prevent fraud. This may include asking you to provide a form of government 
      identification (e.g. driver's license or passport), your date of birth, your address, and other information requiring you to take steps 
      to confirm ownership of your email address, Payment Methods or Payout Methods (&quot;Payment Services&quot;), defined below; or attempting 
      to screen your information against third party databases. OA reserves the right to close, suspend, or limit access to the Payment Services 
      in the event we are unable to obtain or verify any of this information.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">YOUR CONDUCT</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You understand and agree that you are solely responsible for compliance with any and all laws, rules, regulations, and Tax
      obligations that may apply to your use of the Website, App and Services. You agree that you will use the Website only for lawful
      purposes and in accordance with these Terms of Service. You agree that you will not use the Website, Social Media, or Services:
      </span
    >
  </p>

  <p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">In any way that violates any applicable federal, state, or local law or regulation;</span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content,
      asking for personally identifiable information, or otherwise.
    </span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >To send, knowingly receive, upload, download, use, or re-use any material that does not comply with these Terms of Service;
    </span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >To transmit, or procure the sending of, any advertising or promotional material without our prior written consent, including any
      &quot;junk mail&quot;, &quot;chain letter&quot;, &quot;spam&quot;, or any other similar solicitation;</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >To impersonate or attempt to impersonate OA, an employee of OA, another user, or any other person or entity;</span
    >
  </p>

  <p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Website, or which, as determined by us,
      may harm us or our users of the Website or expose them to liability.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d">Additionally, you agree not to:</span>
  </p>

  <p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">Use the Website in any manner that could disable, overburden, damage, or impair it</span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >Use any robot, spider, or other automatic device, process, or means to access the Website for any purpose, including monitoring or
      copying any of the material on the Website;</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >Use any manual process to monitor or copy any of the material on the Website or for any other unauthorized purpose without our prior
      written consent;</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">Use any device, software, or routine that interferes with the proper working of the Website.</span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >Introduce any viruses, Trojan horses, worms, or other material that is malicious or technologically harmful.</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Website, the server on which the Website
      is stored, or any server, computer, or database connected to the Website.</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">Attack the Website via a denial-of-service attack or a distributed denial-of-service attack.</span>
  </p>

  <p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
    <span style="font-family: Symbol; color: #0d0d0d"
      >·
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">Otherwise attempt to interfere with the proper working of the Website.</span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA has the right to investigate and prosecute violations of any of the above to the fullest extent of the law. In addition, and as
      set in these Terms of Service, OA may take a range of actions against you, including but not limited to deactivating or canceling your
      Listing(s) or Account, for a violation of this Section or these Terms of Service. OA may access, preserve and disclose any of your
      information if we are required to do so by law, or if we believe in good faith that it is reasonably necessary to (i) respond to
      claims asserted against OA or to comply with legal process (for example, subpoenas or warrants), (ii) enforce or administer our
      agreements with users, such as these Terms of Service, (iii) for fraud prevention, risk assessment, investigation, customer support,
      product development and de-bugging purposes, or (iv) protect the rights, property or safety of OA, its users, or members of the
      public.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You acknowledge that OA has no obligation to monitor your access to or use of the Website or Service or to review or edit any Content
      (as defined herein) you submit, but has the right to do so for the purpose of operating and improving the Service (including without
      limitation for fraud prevention, risk assessment, investigation and customer support purposes), to ensure your compliance with these
      Terms of Service, to comply with applicable law or the order or requirement of a court, administrative agency or other governmental
      body, to respond to Content that it determines is otherwise objectionable or as set forth in these Terms of Service. OA reserves the
      right, at any time and without prior notice, to remove or disable access to any submissions, postings, or user content (&quot;Content&quot;)
      that OA, at its sole discretion, considers to be objectionable for any reason, in violation of these Terms of Service or otherwise
      harmful to the Service or Website.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">DISCLOSURE OF YOUR PERSONAL INFORMATION</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Personal Information, as further addressed on our Privacy Policy includes your name, address, email, or other identifying
      information. We may access or disclose your Personal Information only if we are required to do so by law, or if we believe in good
      faith that it is reasonably necessary to (i) respond to claims asserted against OA or to comply with legal process (for example,
      subpoenas or warrants), (ii) enforce or administer our agreements with users, such as these Terms, (iii) for fraud prevention, risk
      assessment, investigation, customer support, product development and de-bugging purposes, or (iv) protect the rights, property or
      safety of OA, its users, or members of the public.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Our Privacy Policy (as may be updated from time to time) governs OA's collection and use of your Personal Information.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">INTELLECTUAL PROPERTY OWNERSHIP AND RIGHTS NOTICES</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >The Website, Social Media, App, Service, and all of the content thereon (&quot;OA Content&quot;) are protected by copyright, trademark, and
      other laws of the United States. You acknowledge and agree that the Website, App, Social Media, Service and OA Content, including all
      associated intellectual property rights, are the exclusive property of OA or its licensors. You will not remove, alter or obscure any
      copyright, trademark, service mark or other proprietary rights notices incorporated in or accompanying the Website, App, Service,
      Social Media, or OA Content. All trademarks, service marks, logos, trade names, and any other proprietary designations of OA used on
      or in connection with the Website, App, Service, Social Media, and OA Content (&quot;OA Intellectual Property&quot;) are trademarks or
      registered trademarks of OA in the US. Trademarks, service marks, logos, trade names and any other proprietary designations of third
      parties used on or in connection with the Website, App, Service, Social Media, and OA Content are used for identification purposes
      only and may be the property of their respective owners.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ADDITIONAL TERMS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >From time to time, we may offer additional services to the existing Services on the Website. Additional terms of service may apply
      to those additional offerings and in such case, additional terms of service shall become part of these Terms of Services and
      incorporated herein.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">OA CONTENT AND LICENSE </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Subject to your compliance with these Terms, OA grants you a limited, non-exclusive, non-transferable license, to (i) access and view
      OA Content and OA Intellectual Property solely for your personal purposes and (ii) access and view User Content, defined below, to
      which you are permitted access, solely for your personal purposes. You have no right to sublicense the license rights granted in this
      section. You will not use, copy, adapt, modify, prepare derivative works based upon, distribute, license, sell, transfer, publicly
      display, publicly perform, transmit, broadcast or otherwise exploit the Service, OA Content, OA Intellectual Property, or User Content
      except as expressly permitted in these Terms of Service. No licenses or rights are granted to you by implication or otherwise under
      any intellectual property rights owned or controlled by OA or its licensors, except for the licenses and rights expressly granted in
      these Terms. OA reserves any and all rights not expressly granted herein.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">APP LICENSE </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We grant you a limited, non-exclusive, and nontransferable license to download, install, and use the App for your personal,
      non-commercial use on a single mobile device owned or otherwise controlled by you and to use the OA Content and Services strictly in
      accordance with these Terms of Service. You do not acquire any ownership interest in the App under these Terms of Service, or any
      other rights to the App, other than in accordance with the license granted under these Terms of Service. We retain all right, title,
      and interest in and to the App, including all copyrights, trademarks, and other intellectual property rights, except as expressly
      granted to you in these Terms of Service.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">USER CONTENT </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We may, in our sole discretion, permit you to post, upload, publish, submit or transmit Content (&quot;User Content&quot;)
      on the Website, Social Media or other form. By making available any User Content on or through the Service, or through OA promotional
      campaigns, you hereby grant to OA a worldwide, irrevocable, perpetual (or for the term of the protection), non-exclusive,
      transferable, royalty-free license, with the right to sublicense, to use, view, copy, adapt, modify, distribute, license, sell,
      transfer, publicly display, publicly perform, transmit, stream, broadcast, access, view, and otherwise exploit such User Content to
      use or further the use of the Service. OA does not claim any ownership rights in any User Content and nothing in these Terms will be
      deemed to restrict any rights that you may have to use and exploit any User Content. You acknowledge and agree that you are solely
      responsible for all User Content that you make available through the Service. Accordingly, you represent and warrant that: (i) you
      either are the sole and exclusive owner of all User Content that you make available through the Service or (ii) you have all rights,
      licenses, consents and releases that are necessary to grant to OA the rights in such User Content, as contemplated under these Terms;
      and (iii) neither the User Content nor your posting, uploading, publication, submission or transmittal of the User Content or OA's
      use of the User Content (or any portion thereof) on, through or by means of the Service will infringe, misappropriate or violate a
      third party's patent, copyright, trademark, trade secret, moral rights or other proprietary or intellectual property rights, or rights
      of publicity or privacy, or result in the violation of any applicable law or regulation.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">THIRD PARTY INTEGRATIONS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      The Website may contain links to third-party websites, applications, services, or resources (<b>&quot;Third-Party Services&quot;</b>) that are subject
      to different terms and privacy practices. OA is not responsible or liable for any aspect of such Third-Party Services and links to such Third-Party
      Services are not an endorsement.
    </span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">FEEDBACK</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We welcome and encourage you to provide feedback, comments and suggestions for improvements to the Service (&quot;Feedback&quot;).
      You may submit Feedback by emailing us, through the &quot;Contact&quot; section of the Website and App, or by other means of
      communication. You acknowledge and agree that all Feedback you give us will be the sole and exclusive property of OA and you hereby
      irrevocably assign to OA and agree to irrevocably assign to OA all of your right, title, and interest in and to all Feedback,
      including without limitation all worldwide patent, copyright, trade secret, moral and other proprietary or intellectual property
      rights therein, and waive any moral rights you may have in such Feedback. At OA's request and expense, you will execute documents and
      take such further acts as OA may reasonably request to assist OA to acquire, perfect, and maintain its intellectual property rights
      and other legal protections for the Feedback.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">COPYRIGHT POLICY</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA respects copyright law and expects its users to do the same. OA's policy is to terminate the accounts of an Account holder who
      repeatedly infringes, or who is believed to be repeatedly infringing the rights of copyright holders.</span
    >
  </p>

  <p>
    <u>
      <span style="color: #0d0d0d">Reporting Claims of Copyright Infringement </span>
    </u>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We take claims of copyright infringement seriously. We will respond to notices of alleged copyright infringement that comply with
      applicable law. If you believe any materials accessible on or from this site (the &quot;Website&quot;) infringe your copyright, you
      may request removal of those materials (or access to them) from the Website in accordance the Digital Millennium Copyright of 1998
      the (&quot;DMCA&quot;), the text of which may be found on the U.S. Copyright Office website at http://copyright.gov/legislation/dmca.pdf.
    </span>
  </p>

  <p>
    <u>
      <span style="color: #0d0d0d">Counter-Notification Procedures </span>
    </u>
    <span style="color: #0d0d0d">.</span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >If you believe that User Content or other material you posted on the Website, Social Media or other channels was removed or access to
      it was disabled by mistake or misidentification, you may file a counter-notification with us (a &quot;Counter-Notice&quot;) in accordance with the DMCA.
  </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">TERM AND TERMINATION, SURVIVAL OF TERMS</span>
    </b>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">DISCLAIMERS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >IF YOU CHOOSE TO USE THE SERVICE WHETHER AS A USER, MEMBER, OR LANDOWNER, YOU DO SO AT YOUR SOLE RISK. EXCEPT AS PROVIDED IN THESE
      TERMS, EACH USER, MEMBER OR LANDOWNER IS SOLELY LIABLE FOR HIS/HER USE OF THE SERVICES, UP THROUGH AND INCLUDING A STAY ON A PROPERTY.
      YOU ACKNOWLEDGE AND AGREE THAT OA DOES NOT HAVE AN OBLIGATION TO CONDUCT BACKGROUND CHECKS ON ANY MEMBER, BUT AS A PRACTICE MAY CHOOSE TO
      DO SO. TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, THAT SUCH BACKGROUND CHECKS WILL 
      IDENTIFY PRIOR MISCONDUCT BY A USER OR GUARANTEE THAT A USER WILL NOT ENGAGE IN MISCONDUCT IN THE FUTURE. THE SERVICE (UP THROUGH AND
      INCLUDING THE STAY ON THE PROPERTY BY MEMBER AND HIS/HER GUESTS) IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EITHER
      EXPRESS OR IMPLIED. WITHOUT LIMITING THE FOREGOING, OA EXPLICITLY DISCLAIMS ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
      PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE. OA
      MAKES NO WARRANTY THAT THE SERVICES OR CONTENT, INCLUDING, BUT NOT LIMITED TO THE LISTINGS, WILL MEET YOUR REQUIREMENTS OR BE
      AVAILABLE ON AN UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS. OA MAKES NO WARRANTY REGARDING THE QUALITY OF ANY LISTINGS, PROPERTIES,
      THE SERVICES OR CONTENT OR THE ACCURACY, TIMELINESS, TRUTHFULNESS, COMPLETENESS OR RELIABILITY OF ANY CONTENT OBTAINED THROUGH THE
      SERVICES. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM OA OR THROUGH THE SERVICE, WILL CREATE ANY WARRANTY NOT
      EXPRESSLY MADE HEREIN. YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS OF THE SERVICE,
      INCLUDING WITHOUT LIMITATION MEMBERS AND LANDOWNERS, AND WITH OTHER PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR
      USE OF THE SERVICE. YOU UNDERSTAND THAT OA DOES NOT MAKE ANY ATTEMPT TO VERIFY THE STATEMENTS OF USERS OR TO REVIEW OR VISIT ANY
      PROPERTY. OA MAKES NO REPRESENTATIONS OR WARRANTIES AS TO THE CONDUCT OF USERS OR THEIR COMPATIBILITY WITH ANY CURRENT OR FUTURE USERS
      OF THE SERVICE. YOU AGREE TO TAKE REASONABLE PRECAUTIONS IN ALL COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS AND WITH OTHER
      PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SERVICE, PARTICULARLY IF YOU DECIDE TO MEET OFFLINE OR IN
      PERSON REGARDLESS OF WHETHER SUCH MEETINGS ARE ORGANIZED BY OA. OA EXPRESSLY DISCLAIMS ALL LIABILITY FOR ANY ACT OR OMISSION OF ANY
      LANDOWNER, MEMBER, REGISTERED USER, GUEST OR OTHER THIRD PARTY.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">LIMITATION OF LIABILITY</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >YOU ACKNOWLEDGE AND AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE ENTIRE RISK ARISING OUT OF YOUR ACCESS TO AND USE OF THE
      SERVICE, CONTENT, YOUR LISTING OR BOOKING OF ANY PROPERTY VIA THE SERVICE, AND ANY CONTACT YOU HAVE WITH OTHER USERS OF OA WHETHER IN
      PERSON OR ONLINE REMAINS WITH YOU. NEITHER OA NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE SERVICE WILL BE
      LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOSS OF DATA OR LOSS OF GOODWILL,
      SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF SUBSTITUTE PRODUCTS OR SERVICES, OR FOR ANY DAMAGES FOR
      PERSONAL OR BODILY INJURY OR EMOTIONAL DISTRESS ARISING OUT OF OR IN CONNECTION WITH THESE TERMS, FROM THE USE OF OR INABILITY TO USE
      THE SERVICE, FROM ANY COMMUNICATIONS, INTERACTIONS OR MEETINGS WITH OTHER USERS OF THE SERVICE OR OTHER PERSONS WITH WHOM YOU
      COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SERVICE, OR BOOKING OF ANY PROPERTY VIA THE SERVICE, WHETHER BASED ON WARRANTY,
      CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT OA HAS BEEN INFORMED OF THE
      POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. IN NO EVENT
      WILL OA'S AGGREGATE LIABILITY ARISING OUT OF OR IN CONNECTION WITH THESE TERMS AND YOUR USE OF THE SERVICE INCLUDING, BUT NOT LIMITED
      TO, FROM YOUR LISTING OR BOOKING OF ANY PROPERTY VIA THE SERVICE, OR FROM THE USE OF OR INABILITY TO USE THE SERVICE AND IN CONNECTION
      WITH ANY ACCOMMODATION OR INTERACTIONS WITH ANY OTHER MEMBERS OR LANDOWNERS, EXCEED THE AMOUNTS YOU HAVE PAID, OWE OR RECEIVED FOR
      BOOKINGS VIA THE SERVICE IN THE TWELVE (12) MONTH PERIOD PRIOR TO THE EVENT GIVING RISE TO THE LIABILITY, OR ONE HUNDRED U.S. DOLLARS
      (US$100), IF NO SUCH PAYMENTS HAVE BEEN MADE, AS APPLICABLE. THE LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE THE BASIS OF THE BARGAIN
      BETWEEN OA AND YOU. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES,
      SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">INDEMNIFICATION</span>
    </b>
    <span style="color: #0d0d0d"></span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You agree to release, defend, indemnify, and hold OA and its affiliates and subsidiaries, and their officers, directors, employees
      and agents, harmless from and against any claims, liabilities, damages, losses, and expenses, including, without limitation,
      reasonable legal and accounting fees, arising out of or in any way connected with (a) your access to or use of the Website, App,
      Service, OA Content, OA Intellectual Property or User Content or your violation of these Terms of Service; (b) your User Content; (c)
      your (i) interaction with any Member or Landowner, or other user of the Service or Website (ii) Booking of a Property, or (iii) creation of a Listing;
      and (d) the use, condition or rental of a Property by you, including but not limited to any injuries, losses, or damages
      (compensatory, direct, incidental, consequential or otherwise) of any kind arising in connection with or as a result of a rental,
      Booking or use of a Property.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA is not an owner or operator of any listed Properties, and OA does not own, sell, resell, furnish, provide, manage and/or control
      such Properties or land. Unless explicitly specified otherwise, OA's responsibilities are limited to facilitating the availability of
      the Service. OA MAY ASSIST LANDOWNERS IN CREATING AND MAINTAINING LISTINGS. OA DOES NOT CONTROL THE CONTENT CONTAINED IN ANY LISTINGS
      AND THE CONDITION, LEGALITY OR SUITABILITY OF ANY PROPERTY.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ENTIRE AGREEMENT</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >For purposes of this paragraph, Terms of Service include these Terms of Service, the Privacy Policy, and any applicable Agreements.
      Except as they may be supplemented by additional OA policies, guidelines, standards, or terms for a specific product, feature, service
      or offering, these Terms of Service constitute the entire and exclusive understanding and agreement between OA and you regarding the
      subject matter therein including your use of the Website, App, Service, OA and User Content, and any bookings or Listings of
      Properties made via the Service. These Terms of Service supersede and replace any and all prior oral or written understandings or
      agreements between OA and you.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">ASSIGNMENT</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You may not assign or transfer these Terms of Service, by operation of law or otherwise, without OA's prior written consent. Any
      attempt by you to assign or transfer these Terms of Service or your obligations hereunder, without such consent, will be null and of
      no effect. OA may assign or transfer these Terms of Service, at its sole discretion, without restriction. Subject to the foregoing,
      these Terms of Service will bind and inure to the benefit of the parties, their successors and permitted assigns.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">NOTICES</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Any notices or other communications permitted or required hereunder, including those regarding modifications to these Terms of
      Service, will be in writing and given by OA (i) via email (in each case to the address that you provide) or (ii) by posting to the
      Website or App. For notices made by e-mail, the date of sending will be deemed the date on which such notice is transmitted.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">CONTROLLING LAW AND CHOICE OF VENUE </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >These Terms of Service will be interpreted and governed by the laws of the Commonwealth of Virginia without regard to its choice of
      law principles. The parties agree that any action to enforce these Terms of Service shall be brought in the United States District
      Court for the Eastern District of Virginia, or the Circuit Court for Henrico County, Virginia, and you
      specifically agree to jurisdiction of such courts and venue in such courts.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">NO WAIVER</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >The failure of OA to enforce any right or provision of these Terms of Service will not constitute a waiver of future enforcement of
      that right or provision. The waiver of any such right or provision will be effective only if in writing and signed by a duly
      authorized representative of OA. Except as expressly set forth in these Terms of Service, the exercise of any remedies hereunder will be 
      without prejudice to any other remedies under these Terms of Service or otherwise. If for any reason an arbitrator or a court of competent 
      jurisdiction finds any provision of these Terms of Service invalid or unenforceable, that provision will be enforced to the maximum extent 
      permissible and the other provisions of these Terms of Service will remain in full force and effect.</span
    >
  </p>

  <p>
    <span style="color: #0d0d0d">&nbsp;</span>
  </p>

  <b>
    <i>
      <u>
        <span style="font-size: 11pt; line-height: 107%; font-family: 'Calibri', sans-serif; color: #0d0d0d">
          <br clear="all" style="page-break-before: always" />
        </span>
      </u>
    </i>
  </b>

  <p>
    <b>
      <i>
        <u>
          <span style="color: #0d0d0d">
            <span style="text-decoration: none">&nbsp;</span>
          </span>
        </u>
      </i>
    </b>
  </p>

  <p>
    <b>
      <i>
        <u>
          <span style="font-size: 14pt; line-height: 107%; color: #0d0d0d">Section 2. Member Terms</span>
        </u>
      </i>
    </b>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">BECOMING A MEMBER</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
    Our Premium Membership, which offers discounts and other benefits, can be purchased monthly or annually.  
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">BACKGROUND CHECKS </span>
    </b>
  </p>
  <p>
    <b>
      <i>
        <span style="color: #0d0d0d">DEPENDING ON THE LISTING, YOU MAY BE REQUIRED TO PASS A BACKGROUND CHECK IN ORDER TO USE THE SERVICE. </span>
      </i>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA may conduct background checks on users of the Website who desire to create a Booking (&quot;Background Checks&quot;).
      We use a third-party service, to conduct the Background Checks in accordance with criteria we have determined in our sole discretion.
      Background Check results and all such information are kept confidential by our third-party service provider, Checkr, in accordance with their Privacy Policy found at
      <span class="MsoHyperlink">
        <span style="color: #0d0d0d">
          <a href="https://checkr.com/privacy-policy">
            <span style="color: #0d0d0d">https://checkr.com/privacy-policy</span>
          </a>
        </span> </span
      >.</span
    >
  </p>

  <p>
    <span style="color: #0d0d0d"
      >If you receive information regarding your Background Check for which you have questions or concerns, you will contact Checkr.
      We are not responsible for any errors in the Background Check. If you do not pass the Background Check, you may not have access to all Listings on the Service.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">REFUNDS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      Premium Membership fees are paid in full upon registration. If you choose not to renew your Premium Membership, you will not be charged a renewal fee. 
      For Annual Premium Memberships, you may terminate your membership and receive a pro-rated refund for the unused portion of your term. Monthly subscriptions, 
      however, are not eligible for refunds and will automatically expire at the end of the term.
    </span>
  </p>
  <p>
    <span style="color: #0d0d0d">
      If you wish to terminate your membership or have questions about refunds, please contact us for assistance.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">BOOKINGS AND FINANCIAL TERMS FOR MEMBERS </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >When you, as a Member, choose to book a Property and enter into a transaction with a Landowner (&quot;Booking&quot;), you agree and understand
      that you will be required to enter into an agreement with that Landowner and you agree to accept any terms, conditions, rules and
      restrictions associated with such Property imposed by the Landowner in the Listing Rules (&quot;Booking Terms&quot;). Landowners are solely responsible for honoring
      confirmed Bookings and making the Property available to you under the Booking Terms. You acknowledge and agree that you, and not OA,
      are solely responsible for performing the obligations of the Booking and the Booking Terms. Further you acknowledge and agree that OA
      is not a party to such agreements, and we disclaim all liability arising from or related to any such agreements. All fees payable to
      Landowner (&quot;Total Fees&quot;) will be displayed to a Member before the Member sends a Booking request to a Landowner. You as a Member agree
      to pay the Total Fees for any Booking requested and confirmed in connection with your Account in accordance with these Terms of
      Service. Once your confirmed Booking is complete you will receive a confirmation email summarizing your confirmed Booking and any
      Booking Terms.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">MEMBERS PAYMENT METHODS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >All transactions are governed by the terms and conditions of our third-party payment processor, Stripe. 
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You as a Member authorize OA or its agent to collect your payment method information (e.g. credit card information, routing and bank account
      numbers, expiration dates, a &quot;Payment Method&quot;) and charge your Payment Method as outlined in these Terms of Service.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >If your Payment Method information changes (e.g. new account number, routing number, expiration date) you must update your Payment
      Method on file in your OA Account.&#8239;
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You as a Member agree that OA or its agent may charge your Payment Method the Total Fee for any Booking requested in connection with your Account
      upon confirmation of the Booking.  </span
    >
  </p>

  <p>
    <span style="color: #0d0d0d"
      >As a general rule, OA will collect the Total Fee when the Property is booked. Upon completion of Booking, you will receive a
      confirmation email summarizing your confirmed Booking.&#8239; You agree to pay us for any confirmed Bookings and authorize the
      collection of such amounts by charging the Payment Method provided as part of requesting the Booking. You also authorize OA to charge
      any Payment Method in your Account in the event of damage caused at or to a Property as contemplated under the section entitled
      &quot;Damage to Property&quot; below. If OA is unable to collect any amounts you owe for a confirmed Booking or a Damage Claim (as
      defined below), OA may engage in collection efforts to recover such amounts from you. You agree that all communication in relation to
      amounts owed will be made by electronic mail or by phone. Such communication may be made by OA or by anyone on their behalf.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Please note that OA cannot control any fees that may be charged to a Member by his or her bank related to OA's collection of the
      Total Fees and OA disclaims all liability in this regard.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Your Payment Method may be subject to additional terms and conditions imposed by Stripe and should be reviewed prior to any
      transaction.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">CANCELLATIONS AND REFUNDS FOR BOOKINGS </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      Our ability to refund any portion of the Total Fee charged to you will depend upon the terms of the applicable Cancellation Policy(s).   
    </span>
  </p>

  <p>
    <u>
      <span style="color: #0d0d0d">Cancellation by Landowner:</span>
    </u>
    <span style="color: #0d0d0d"> If a Landowner cancels a confirmed Booking, OA will refund to the applicable Member the Total Fee for such Booking. 
      The Member may receive an email or other communication from OA containing alternative Listings and other related information. 
      If a Landowner cancels a confirmed Booking, the Landowner or OA will contact the Member.
    </span>
  </p>

  <p>
    <u>
      <span style="color: #0d0d0d">Cancellation by OA:</span>
    </u>
    <span style="color: #0d0d0d"> 
      In certain circumstances, OA may decide, in its sole discretion, that it is necessary or desirable to cancel a confirmed Booking and may, 
      in its sole discretion, decide to refund part or all of the amounts charged to the Member. Neither OA or Member shall be liable to Landowner 
      for such cancellations or refunds.
    </span>
  </p>

  <p>
    <u>
      <span style="color: #0d0d0d">Cancellation by Member:</span>
    </u>
    <span style="color: #0d0d0d"> 
      Each Booking has its own cancellation policy as determined by Outdoor Access and the landowner. Individual cancellation policies can be reviewed 
      at check-out via either the "Outdoor Access Daily Lease Agreement" or the "Outdoor Access Seasonal Lease Agreement" depending on the type of booking. 
      These agreements are also available to members after making a booking via the "My Leases" section of their account.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">PAYMENT PROCESSING ERRORS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >If you think your Payment Method has been wrongly charged, please notify us immediately. We will take steps to rectify any payment
      processing errors of which we become aware.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">BOOKING MODIFICATIONS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Members and Landowners are responsible for modifications to Bookings that you direct OA Customer Service to make (&quot;Booking
      Modifications&quot;), and you agree to pay any applicable fees associated with such Booking Modifications.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">RESPONSIBILITY FOR SAFETY AND INDEMNIFICATION</span>
    </b>
  </p>
  <p>
    <span style="color: #0d0d0d">
      Outdoor Access Inc. and Landowners assume no responsibility for the safety of Members and registered or unregistered participants joining the member (&quot;Guests&quot;)
      Members hereby assume all such responsibility. Outdoor Access Inc. and Landowners shall not be liable for any injury or death incurred by members or their Guests.
    </span>
  </p>
  <p>
    <span style="color: #0d0d0d">
      With any Booking through www.outdooraccess.com, Members hereby finally
      and irrevocably release and discharge Outdoor Access, Inc, a Delaware Corporation, and the Landowner of the Property on behalf of themselves and their Guests 
      for any injury or death occurring as a results of the Services or a Booking.
    </span>
  </p>
  <p>
    <span style="color: #0d0d0d">
      Members and their Guests recognize that many recreational activities are potentially dangerous and could result in serious bodily
      injury or death. This release is given in consideration of any recreational opportunity granted by Outdoor Access, Inc. to Member.
    </span>
  </p>
  <p>
    <span style="color: #0d0d0d">
      To the extent that a Guest is a minor, the Member releases Outdoor Access Inc and the Landowner from any liability in the same manner as
      though the minor were an adult. To the extent that the Member is an adult accompanied in any recreational activity by a minor
      child, the Member hereby executes this release on behalf of said minor child and agrees to indemnify Outdoor Access Inc and the Landowner for any
      damage, claim, or cause of action made by said minor against Outdoor Access Inc. or the Landowner. The Member hereby agrees to
      take full and adequate steps to ensure that any minor child accompanying the Member on
      any recreational activity at or adjacent to the Property has been adequately trained in safety precautions
      associated with the use of any equipment associated with the recreational activity.
    </span>
  </p>
  <p>
    <span style="color: #0d0d0d">
      The Member is aware of, and acknowledges, the dangers which exist from participating in certain recreational
      activities, specifically hunting, without appropriate eye protection. Members and Guests must provide their own eye protection or,
      if they choose not to provide eye protection they further acknowledge that by making a personal determination not to use or wear
      safety glasses, they are assuming the risk of eye injury that might otherwise be prevented.
    </span>
  </p>
  <p>
    <span style="color: #0d0d0d">
      This release and waiver shall be construed broadly to provide a release and waiver to the maximum extent permissible under applicable
      law.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">DAMAGE TO PROPERTY</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      Members are responsible for leaving Property in the condition in which it was found when you arrived. You acknowledge and agree that
      you are responsible for your own acts and omissions while on the Property and for the acts and omissions of those individuals whom you
      invite to, or otherwise provide access to the Property, in accordance with these Terms of Service. In the event that a Landowner
      claims and provides evidence of damage (&quot;Damage Claim&quot;), including but not limited to photographs, you agree to pay the cost
      of repair, including replacement of damaged items, if applicable. Both Members and Landowners agree to cooperate with and assist OA in
      good faith, and to provide OA with such information and take such actions as may be reasonably requested by OA, in connection with any
      Damage Claims or other complaints or claims made by Landowners relating to Properties or any personal or other property located at a
      Property, or with respect to any investigation undertaken by OA or a representative of OA regarding Damage Claims. As a Member, you
      understand and agree that OA may make a claim under any relevant insurance policy of yours related to any damage or loss that you may
      have caused or been responsible for or to a Property or any personal or other property located at a Property. You agree to cooperate
      with and assist OA in good faith, and to provide OA with such information as may be reasonably requested by OA, in order to make a
      claim under your insurance policy, including, but not limited to, executing documents and taking actions reasonably requested by OA to
      assist in accomplishing the foregoing.</span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">OVERSTAYING WITHOUT LANDOWNER'S CONSENT</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      Members agree that a confirmed Booking is merely a license granted by the Landowner to the Member to enter and use the Property for
      the term of the Booking only and in accordance with the Booking Terms. Members must leave the Property by the checkout time specified
      by the Landowner on the Booking Terms or the Listing, or such other time as mutually agreed upon between the Landowner and Member. If
      a Member remains on the Property without the Landowner's consent, they may be considered to be trespassing on Landowner's property and
      Landowner is entitled to make the Member leave.</span
    >
  </p>

  <p>
    <span style="color: #0d0d0d"
      >For each 24-hour period that the Member stays over the agreed period without the Landowner's consent, an additional daily fee of two
      times the average daily Rental Fee for the Booking, plus any additional Fees, Taxes, and any legal expenses incurred by the Landowner
      to make the Member leave (collectively, &quot;Additional Sums&quot;) shall be charged to Member. OA will collect Additional Sums from
      Members pursuant to the Payments Terms.</span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">TRESPASSING/COMING ONTO PROPERTY WITHOUT PERMISSION</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      A Member shall be immediately terminated from membership with OA and shall not be entitled to any refunds in the event OA reasonably
      believes that a Member has trespassed on a Property or is otherwise on the Property without the permission and consent (as evidenced
      by a Booking) of the Landowner. OA and Landowner reserve the right to have a trespassing or allegedly trespassing Member prosecuted to
      the fullest extent of the law.</span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">COMPLIANCE WITH ALL LAWS AND REGULATIONS. </span>
    </b>
    <span style="color: #0d0d0d"
      >You are solely responsible for complying with all applicable state, federal or local laws, regulations, permitting or
      licensing requirements, and any and all other rules pertaining to your planned activity on the Property during your stay.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >OA shall not be liable to you or Landowner for any violation by Member, Member's guests or any other party associated with a Booking
      for violations of applicable laws and regulations.
    </span>
  </p>

  <p>
    <b>
      <i>
        <u>
          <span style="font-size: 14pt; line-height: 107%; color: #0d0d0d">Section 3: Landowner Terms </span>
        </u>
      </i>
    </b>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">LISTINGS </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >As a Landowner, you may create Listings. To create a Listing, you will be asked a variety of questions about the Property to be
      listed, including, but not limited to, the location, size, features, amenities, available game for hunting, and availability of the
      Property and pricing and related rules and financial terms. Listings will be made publicly available via the Service for all visitors
      to the Site or App regardless of their registration or Member status.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >You understand and agree that the placement or ranking of Listings in search results within OA may depend on a variety of factors,
      including, but not limited to, Member and Landowner preferences, ratings and/or ease of booking. Members will be able to book your
      Property via the Service based upon the information provided in your Listing, your Member requirements, and Members' search parameters
      and preferences. You understand and agree that once a Member requests a Booking of your Property, you may not request the Member to
      pay a higher price than in the Booking request or change any other material terms of the Listing. You acknowledge and agree that you
      alone are responsible for any and all Listings that you post or direct OA to post on your behalf.
    </span>
  </p>

  <p>
    <b>
      <u>
        <span style="color: #0d0d0d">License</span>
      </u>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >By using the Service, directing OA to create a Listing on your behalf, or creating a Listing you herby agree that any information whatsoever concerning 
      the Property or the Listing,
      including but not limited to information, photographs and images of the Property and associated buildings, structures or other
      landmarks, images of the Landowner, images of the Member or information regarding Members who have booked or stayed on the Property
      (&quot;Content&quot;) provided by you is considered non-confidential and non-proprietary. You grant us, our affiliates, service providers and
      each of our respective licensees, successors and assigns a non-exclusive, non-transferable right to use, reproduce, transmit, publish,
      display and otherwise share the Content on or through the Website and App and for marketing, promotion and advertisement of OA and our
      services on and across all platforms and in any media now known or later created.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d">You represent and warrant that:</span>
  </p>

  <p class="MsoListParagraphCxSpFirst" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >a.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">You have the legal authority to offer the property for use on the platform.</span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >b.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">You own all rights to the Content and/or have the right to grant us the rights set forth herein;</span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >c.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >The Content will not breach any agreements you have entered into with any third parties, such as lease or rental agreements;</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >d.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >The Content will be in compliance with all applicable laws (such as zoning) and tax requirements, and all rules and regulations that
      may apply to any Property included in a Listing;</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >e.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >You have all the required permits, licenses and registrations pertaining to the use of your Property and your ability to list such
      Property;
    </span>
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >f.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >Images or pictures in the Content will not violate any intellectual property laws or rights of third parties;</span
    >
  </p>

  <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >g.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d">Content will comply with these Terms of Use;  </span>
  </p>

  <p class="MsoListParagraphCxSpLast" style="margin-bottom: 0cm; margin-bottom: 0.0001pt; text-indent: -18pt">
    <span style="color: #0d0d0d"
      >h.
      <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
    </span>
    <span style="color: #0d0d0d"
      >You are responsible for any Content you submit or contribute, and you, not us, have full responsibility for such Content, including
      its legality, reliability, accuracy, and appropriateness.</span
    >
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <span style="color: #0d0d0d">&nbsp;</span>
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <span style="color: #0d0d0d"
      >We are not responsible or liable to any third party for the Content posted by you and you are solely responsible for complying with
      all applicable laws, rules and regulations pertaining to Content. OA reserves the right, at any time and without prior notice, to
      remove or disable access to any Listing or remove Content for any reason, including Listings or Content that OA, in its sole
      discretion, consider to be objectionable or harmful for any reason or is in violation of these Terms of Service, our Privacy Policy,
      or other Agreements.</span>
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <span style="color: #0d0d0d">&nbsp;</span>
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <b>
      <span style="color: #0d0d0d">REMOVAL OF LISTING</span>
    </b>
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <span style="color: #0d0d0d">&nbsp;</span>
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <span style="color: #0d0d0d">
      Landowners can remove or delete a Listing at any time or can contact OA to do so. Upon deactivation or removal, any images of the
      Property or Listing information shall also be removed.
    </span>
  </p>

  <p style="margin-bottom: 0cm; margin-bottom: 0.0001pt">
    <span style="color: #0d0d0d"> </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">OA NOT AN INSURER</span>
    </b>
    <span class="MsoCommentReference">
      <span style="font-size: 8pt; line-height: 107%; color: #0d0d0d"> </span>
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d">
      OA does not act as an insurer or as your contracting agent. If a Member requests a Booking of your Property and stays at your
      Property, any agreement you enter into with such Member is between you and the Member and OA is not a party to it. When you create a
      Listing, you may also choose to include certain requirements which must be met by the Members who are eligible to request a Booking of
      your Property, such as requiring Members to have a profile picture or verified phone number, in order to Book your Property. Any
      Member wishing to Book Properties included in Listings with such requirements must meet these requirements. If you are a Landowner, OA
      makes certain tools available to you to help you to make informed decisions about which Members you choose to confirm or preapprove
      for Booking for your Property. You acknowledge and agree that, as a Landowner, you are responsible for your own acts and omissions and
      are also responsible for the acts and omissions of any individuals who reside at or are otherwise present at the Property at your
      request or invitation, excluding the Member.
      <b>Neither OA nor its agents is responsible for or has any liability with respect to your Property or Listing(s) during any period other than for the 
        agreed upon duration of a Booking.
      </b>
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">INDEPENDENT REPRESENTATIVES</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      Landowners may, at your sole discretion, engage one or more third-party &quot;Independent Representative(s)&quot; to handle management of
      Bookings, meeting with Members at the Property to facilitate a positive Member experience, management of the Properties, or any other
      authorized activity as agreed to between the Landowner and the Independent Representative in writing. The Landowner is solely
      responsible for the Property and Listing regardless of whether or not Landowner has engaged an Independent Representative. If a
      Landowner has notified OA in writing that he/she is utilizing an Independent Representative, OA shall be authorized to contact and
      look to such Independent Representative, and such Independent Representative shall be authorized by Landowner to, provide resolution
      of any questions, issues, or concerns regarding the Property, the Listing or any Booking.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >We shall not be held responsible or liable for reliance on such Independent Representative's representations or authorization of
      Bookings, Listings or other duties hereunder.
    </span>
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">BOOKINGS AND FINANCIAL TERMS FOR LANDOWNERS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >When a Booking is requested via the Service, we will share with Landowners (i) the first and last name of the Member who has
      requested the Booking, and (ii) a link to the Member's Account profile page or Member's contact information. OA will send you an
      email, text message or message via the App confirming such Booking, depending on the preferences you have selected on your own Account
      and the selections you make when a Listing is created.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d">
      Each Landowner agrees that OA may, in accordance with the OA Cancellation Policy (i) permit the Member to cancel the Booking and (ii)
      refund to the Member that portion of the Total Fees specified in the Member Cancellation Policy.
    </span>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >If, as a Landowner, you cancel a confirmed Booking, you agree that OA may apply penalties or consequences to you or your Listing,
      including (i) publishing an automated review on your Listing indicating that a Booking was cancelled, (ii) keeping the calendar for
      your Listing unavailable or blocked for the dates of the cancelled Booking, or (iii) imposing a cancellation fee.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">TAXES</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >Upon request we will send you the appropriate tax forms. If you have questions regarding which forms you need, please contact your
      accountant or another tax professional. OA cannot and does not offer Tax-related advice to any Members or Landowners. You understand
      and acknowledge that appropriate governmental agencies, departments or authorities (the &quot;Tax Authority&quot;) where your Property
      is located may require Taxes to be collected from Members or Landowners and to be remitted to the respective Tax Authority.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">REPORTING MEMBER MISCONDUCT </span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d"
      >If you as a Landowner host any Member who you feel is acting or has acted inappropriately, including but not limited to Members or
      their guests who (i) engage in offensive, violent or sexually inappropriate behavior, (ii) you suspect of stealing from you, or (iii)
      engage in any other disturbing conduct, you should immediately report such person to the appropriate authorities and then to OA by
      contacting us with your police station and report number; provided that your report will not obligate us to take any action beyond
      that required by law (if any) or cause us to incur any liability to you.</span
    >
  </p>

  <p>
    <b>
      <span style="color: #0d0d0d">KNOW YOUR LEGAL OBLIGATIONS</span>
    </b>
  </p>

  <p>
    <span style="color: #0d0d0d">
      You are responsible for understanding and complying with any laws, rules, regulations, and contracts with third parties that apply to your Property or Listing(s). 
      Information we provide regarding legal requirements is for informational purposes only and you should independently confirm your obligations. You are responsible 
      for handling and using personal data of Members and Guests in compliance with applicable privacy laws and these Terms. If you have questions about how local laws 
      apply you should always seek legal advice.
    </span>
  </p>

  <p>
    <b>
      <i>
        <u>
          <span style="font-size: 14pt; line-height: 107%; color: #0d0d0d">Section 4: Rules Applying to the use of all Outdoor Access Listings & License Purchase Indemnity Agreement  </span>
        </u>
      </i>
    </b>
  </p>

  <p>
    In addition to the accepting the Terms of Service and “House Rules” unique to each listing, the following rules apply to use of all listings on the Outdoor Access website. When purchasing a License, all Licensee’s and members of the License Group agree:  
  </p>
  <ol>
    <li>To not sublicense the Premises, nor grant permission to anyone who is not a party to this Agreement or a member of the License Group to hunt or otherwise use the Premises. For purposes of this Agreement, the License Group shall be defined as the Licensee, and other named individuals up to the maximum number allowed by Listing Rule.</li>
    <li>To abide by any and all Federal, State and Local laws and regulations while using the property. To abide by any and all Landowner prescribed house rules and quotas stipulated in the Listing Rules section. Failure to follow said regulations, by Licensee or other member of the designated Licensee Group may, at Landowner's option, cause immediate cancellation of the Agreement as to that Licensee or to all Licensees (at Landowner's sole discretion) and without refund of all fees paid or any portion of the Deposit.</li>
    <li>To maintain proper safety procedures regarding firearms, including but not limited to, ensuring that all firearms are unloaded in all vehicles and structures. To not load firearms except while actively hunting or shooting in an area safe to do so.</li>
    <li>If allowed by listing rule, to insure all users and passengers of ATV’s, UTV’s and other offroad vehicles follow appropriate safety guidelines published by the vehicle manufacturer including but not limited to the MANDATORY WEARING OF HELMETS.</li>
    <li>To insure motorcycles are not used on listings at any time.</li>
    <li>To ensure that vehicles are driven only on established roads and trails, and that all gates are left as originally found prior to passing through them. To insure vehicles do not cause damage to established roads and trails, and to be especially mindful of the potential for damage when roads and trails are damp or wet.</li>
    <li>If allowed by listing rule, to insure all users of elevated hunting stands and blinds follow appropriate safety guidelines published by the manufacturer including but not limited to the MANDATORY USE of TREE STAND SAFETY HARNESSES.</li>
    <li>To maintain proper vigilance aimed at preventing fires or damage by other means to the Premises, and to immediately report any wildfires that may occur on the Premises to appropriate authorities and Landowner.</li>
    <li>To maintain a no hunting or shooting zone within 100 yards of any occupied building and around all other designated areas. Local or state minimum regulated distances will supersede this distance if more than 100 yards. </li>
    <li>To remove all personal property or structures placed or constructed by Licensee upon the Premises at termination of this Agreement unless the Landowner has provided prior written consent to leave any or all such property. Personal property and/or structures shall become possession of the Landowner at the end of the term of this agreement. Nothing in this paragraph shall be construed as granting Licensee the right to place or construct any structure on the Premises. </li>
    <li>To repair any damage caused to the Premises and to return the Premises to the Landowner in the same condition that existed upon commencement of the Agreement. Any clearing of underbrush must be done in a manner so as not to damage any trees or crops that have been planted and only after receiving written permission to do so from the License Agent. </li>
    <li>To in no way hinder forestry or farming operations or to damage crops or trees. </li>
    <li>To pay for all damages caused by Licensee and the other members of his or her license group.</li>
    <li>To not enter upon any neighboring land or trespass or hunt on any land not described herein. </li>
    <li>To clean up after yourself and leave only your footprints; to keep the Premises free of litter at all times.</li>
  </ol>
  <p>As further consideration for the rights and privileges granted when purchasing a License, Licensee and License Group agree to the following: </p>
  <ol>
    <li>It is understood that the Premises consists of mostly undeveloped and untamed land, and the Licensee has had an opportunity to inspect the Premises and accepts the Premises in an "as is" condition and further, the Licensee understands that hunting is a dangerous activity and that there may be hazards (known and unknown, hidden and observable), including but not limited to, dangers such as holes, cracks or openings in the earth, fence wire, snakes, wells, swamps, brush and other growth, ponds, harmful plants, wild or poisonous animals, insects, bats, unauthorized or careless persons on the land, other hunters, or other risks that may be dangerous and cause injury and/or death and that Licensee assumes all such risks as his/her own responsibility, without liability to or recourse against the Landowner, Landowner's Agent or their agents, officers, directors, employees, assignees and heirs. </li>
    <li>Licensee recognizes the inherent dangers associated with hunting and outdoor recreation, both natural and human-created. Licensee recognizes that accidents involving firearms, ammunition, falling trees, and animals and various other dangers may forcibly occur on the Premises. Licensee acknowledges his/her recognition of these dangers and the possible existence of dangerous physical conditions upon the Premises. With the aforementioned recognitions in mind, Licensee agrees to indemnify and hold harmless Landowner and Landowner’s Agent, and all of his/her family, servants, employees and agents from all claims, suits, losses, personal injuries, deaths, property liability and all other liability resulting directly or indirectly from or on account of hunting activities engaged in by Licensee or Licensee's guests on the Premises. Obligations to indemnity extend to the reimbursement of Landowner for all expenses and suits including but not limited to judgements, attorneys' fees and court costs. </li>
    <li>That although Landowner may have a greater knowledge of the Premises than Licensee, that it is impracticable and virtually impossible for Landowner to list and/or to physically show Licensee each and every potential hazard on the Premises and Licensee enters onto said Premises despite same and at Licensee's own risk and without liability to Landowner, Landowner's Agent or their agents, officers, directors, employees, assignees and heirs. </li>
    <li>To forever release, defend, indemnify, and hold harmless Landowner and Landowner's Agent, their agents, officers, directors, employees, assigns and heirs, from and against any and all liability, claims, fines, settlements, damages, demands, suits or causes of action of whatsoever nature, including but not limited to reasonable attorney's fees, arising out of bodily injury to, illness or death of any person, including Licensee or other member of the License Group, damage to property of any person, legal entity, or third party, in any occurrence incident to or arising out of or relating to this Agreement or any activities occurring upon the Premises, whether by Licensee or otherwise; the performance or non-performance by Licensee of its obligations hereunder; a breach of any term, provision or warranty contained in this Agreement; or any violation of any laws, regulations or ordinances related to Licensee's obligations or performance hereunder.</li>
  </ol>


</div>

<div></div>
